import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import TogglerCheckbox from 'modules/core/components/Inputs/TogglerCheckbox'
import i18n from 'modules/core/lib/i18n'

import type { ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import FieldSet from 'modules/reviews/components/FieldSet'
import ManualSelection from 'modules/reviews/components/New/AccessGroupPicker/ManualSelection'

interface Props {
  respondentsForm: Form & {
    manualMembers: number[]
  }
  contractVersions: ContractVersions
}

function Respondents({ respondentsForm, contractVersions }: Props) {
  const setManualMembers = (members: number[]) => {
    respondentsForm.manualMembers = members
  }

  return (
    <FieldSet
      title={i18n.t('surveys.performance.new.form.respondents.title')}
      description={i18n.t('surveys.performance.new.form.respondents.description')}
    >
      <Box gap="s16">
        <TogglerCheckbox.Container>
          <TogglerCheckbox
            field={respondentsForm.get('self')}
            label={i18n.t('surveys.performance.new.form.labels.self')}
          />
          <Text.Normal>
            {i18n.t('surveys.performance.new.form.respondents.self.description')}
          </Text.Normal>
        </TogglerCheckbox.Container>
        <TogglerCheckbox.Container>
          <TogglerCheckbox
            field={respondentsForm.get('manager')}
            label={i18n.t('surveys.performance.new.form.labels.managers')}
          />
          <Text.Normal>
            {i18n.t('surveys.performance.new.form.respondents.managers.description')}
          </Text.Normal>
        </TogglerCheckbox.Container>
        <TogglerCheckbox.Container>
          <TogglerCheckbox
            field={respondentsForm.get('reportees')}
            label={i18n.t('surveys.performance.new.form.labels.reportees')}
          />
          <Text.Normal>
            {i18n.t('surveys.performance.new.form.respondents.reportees.description')}
          </Text.Normal>
        </TogglerCheckbox.Container>
        <TogglerCheckbox.Container>
          <TogglerCheckbox
            field={respondentsForm.get('peers')}
            label={i18n.t('surveys.performance.new.form.labels.peers_label')}
          />
          <Text.Normal>
            {i18n.t('surveys.performance.new.form.respondents.peers.description')}
          </Text.Normal>
        </TogglerCheckbox.Container>
        <TogglerCheckbox.ExpandableContainer open={Boolean(respondentsForm.get('manual').value)}>
          <Box>
            <TogglerCheckbox
              field={respondentsForm.get('manual')}
              label={i18n.t('surveys.performance.new.form.labels.manual_label')}
            />
            <Text.Normal>
              {i18n.t('surveys.performance.new.form.respondents.manual.description')}
            </Text.Normal>
          </Box>
          <Box padding="s24" background="grey100">
            <ManualSelection
              everybody
              members={respondentsForm.manualMembers}
              setMembers={setManualMembers}
              contractVersions={contractVersions}
            />
          </Box>
        </TogglerCheckbox.ExpandableContainer>
      </Box>
    </FieldSet>
  )
}

export default observer(Respondents)
